import React from 'react'
import { PageNotFound } from 'component-library/errors/PageNotFound/PageNotFound'
import { StyledMessage } from './PerthNowPageNotFound.styled'
import { Box } from 'component-library/compositions/Box/Box'

export const PerthNowPageNotFound = () => (
    <React.Fragment>
        <PageNotFound attribution />
        <Box verticalSpacing="xxl" hasTopSpacing={false}>
            <StyledMessage>
                <p>The page must have been moved or deleted.</p>
                <p>
                    Click the browser back button to return to the previous page or check out our
                    top headlines below.
                </p>
            </StyledMessage>
        </Box>
    </React.Fragment>
)
